import { useEffect, useState } from "react";

import { getDecoColumns } from "./misc/deco-columns";
import useAxios from "@hooks/use-axios";
import { useParams } from "react-router-dom";
import useSearchParams from "@hooks/use-search-params";

export const useTeamPerformance = () => {
    const { platformId } = useParams();  
    const { axiosInstance, loading, cancelAllRequests } = useAxios({
        base         : "panel",
        initialLoader: true
    });
    const [data, setData] = useState({ users: [], aott: 0, aodt: 0, act: 0, anc: 0, pagination: {} });
    const [queryParams, setQueryParams] = useState({});
    const { getSearchParams } = useSearchParams();
   
    const getTeamPerformance = async () => {
        const { data, pagination } = await axiosInstance.get(`/report/${platformId}/team-performance`, {
            params: {
                start: getSearchParams("start"),
                end  : getSearchParams("end"),
                page : getSearchParams("page"),
                limit: getSearchParams("limit"),
                ...queryParams
            }
        });

        setData({
            users: data.users || [],
            aott : data.aott,
            aodt : data.aodt,
            act  : data.act,
            anc  : data.anc,
            pagination
        });
    };

    useEffect(() => {
        let isActive = true;
        if (isActive) {
            getTeamPerformance();
        }
        return () => {
            isActive = false;
            cancelAllRequests();
        };
    }, [queryParams]);

    return {
        data,
        loading,
        columns: getDecoColumns(),
        setQueryParams,
        getTeamPerformance
    };
};
